export const blackListedNumbers = [
  "1234567890",
  "0123456789",
  "0612345678",
]